import React from 'react';
import Header from '../components/Header';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function ErrorPage() {
  const location = useLocation();
  const state = location.state || {};

  useEffect(() => {
    if (state.showWidget) {
      const script = document.createElement('script');
    
      script.src = "generatorV.js";
      script.async = true;
    
      document.body.appendChild(script);
    
      return () => {
        document.body.removeChild(script);
      }
    }
  }, []);


  return (
    <div className="tourmaster-page-wrapper tourmaster-payment-style-1 tourmaster-template-payment" id="tourmaster-page-wrapper">
        <Header currentStep="none" tourName={state.excursionName}/>
        <div className="tourmaster-template-wrapper" id="tourmaster-payment-template-wrapper">
          <div className="tourmaster-container">
            <div className="tourmaster-page-content tourmaster-item-pdlr clearfix">
                <div className="tourmaster-tour-payment-error">
                    <h4>{state.errorLine1}</h4>{state.errorLine2}
                </div>
                <div id="EE_widget" tourid={state.inputs?.excursionId} inputs={JSON.stringify(state.inputs)}></div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default ErrorPage;